import { FormGroupRules } from '@shared/models/interfaces/form-group-rules.model';
import { addRemoveError, getControl } from '@shared/helpers/form.helper';
import { formPaths } from '@shared/constants/form-paths.const';
import { toNum } from '@shared/helpers/math.helper';
import { isNilOrEmpty } from '@shared/helpers/utils.helper';
import { REQUIRED_STATUS } from '@shared/constants/shared.constants';
import { FormGroup } from '@angular/forms';
import { isEqual } from 'lodash-es';
import { getBaseSocialeControl } from './helpers/base-sociale-form.helper';

export const baseSocialeAttivitaRules: FormGroupRules = {
    my_CkAlboImpreseArtigiane: (form: FormGroup) => {
        isRequiredByNormeSocioLavoratAndTipoSezEnte(form, 'my_gruppo15.my_CkAlboImpreseArtigiane');
    },

    my_ckAttivFacchin: (form: FormGroup) => {
        isRequiredByNormeSocioLavoratAndTipoSezEnte(form, 'my_gruppo13.my_ckAttivFacchin');
    },

    my_ckAttivFacchinaggio: (form: FormGroup) => {
        isRequiredByNormeSocioLavoratAndTipoSezEnte(form, 'my_gruppo13.my_ckAttivFacchinaggio');
    },

    my_ckAttivFacchinaggioEsclus: (form: FormGroup) => {
        const my_ckAttivFacchin = toNum(getControl(form, `${formPaths.baseSociale}.my_gruppo13.my_ckAttivFacchin`)?.value);
        isRequiredByNormeSocioLavoratAndTipoSezEnte(form, 'my_ckAttivFacchinaggioEsclus', my_ckAttivFacchin === 1);
    },
};

const isRequiredByNormeSocioLavoratAndTipoSezEnte = (form: FormGroup, targetPath: string, suppCondition = true) => {
    const targetControl = getBaseSocialeControl(form, targetPath);
    const targetNameSplitted = targetPath?.split('.');
    const errorName = targetNameSplitted[targetNameSplitted.length - 1];
    const my_CkNormeSocioLavorat = toNum(getBaseSocialeControl(form, 'my_CkNormeSocioLavorat')?.value);
    const my_TipoSezEnte = toNum(getControl(form, `${formPaths.datiIdentificativi}.my_TipoSezEnte`)?.value);
    const errors = targetControl.errors ? targetControl.errors : {};
    const showError = isNilOrEmpty(targetControl?.value) && my_CkNormeSocioLavorat === 1 && (my_TipoSezEnte === 2 || my_TipoSezEnte === 5) && suppCondition;

    addRemoveError(showError, errors, errorName, {
        status: REQUIRED_STATUS,
    });

    targetControl.setErrors(isEqual(errors, {}) ? null : errors);
};
